import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
    content: {
        padding: theme.spacing(2),
    },
    tableButton: {
        padding: '6px',
        borderRadius: '50%',
        transition: 'background 0.3s ease',
        '&:hover': {
            background: 'lightgrey',
        },
        '&:hover:active': {
            background: '#e8e8e8',
        },
    },
}));
